

import axios from "axios";

export const axiosClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`, // uses environment variable
});

// Automatically include JWT token from localStorage
axiosClient.interceptors.request.use(config => {
  const user = JSON.parse(localStorage.getItem("User"));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

